<template>
    <div>
        <VillagesTopNav @leftIconFun="()=>{this.$router.go(-1);}">
            <h2 slot="content">我的评论</h2>
        </VillagesTopNav>
        <div class="my-comment">
            <template v-for="item in newsData">
                <myComent :data="item"></myComent>
            </template>
        </div>
    </div>
</template>
<script>
    import VillagesTopNav from '../../components/VillagesTopNav.vue'
    import myComent from '../../components/myComent.vue'
    export default {
        components: {
            VillagesTopNav,
            myComent
        },
        data(){
            return {
                newsData:[{
                    title:"我评论了：您好，您的微信加不上，请问怎么联系你呢？",
                    author:"飞翔的鸟",
                    content:'家中有旧的洗衣机，需要的联系我15866662222'
                },{
                    title:"我评论了：您好，您的微信加不上，请问怎么联系你呢？",
                    author:"飞翔的鸟",
                    content:'家中有旧的洗衣机，需要的联系我15866662222'
                }],
            }
        }
    }
</script>
<style scoped>
    h2{
        font-size:36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:50px;
    }
</style>